import * as React from "react";
import {
  Fab,
  Typography,
  CircularProgress,
  Alert,
  Box,
  Pagination,
  Stack,
} from "@mui/material";
import AddToPhotosOutlinedIcon from "@mui/icons-material/AddToPhotosOutlined";
import { useNavigate } from "react-router-dom";
import { PaymentsType } from "../../types/entitiesModel";
import AppTablePayments from "../tables/AppTablePayments";
import { AuthContext } from "../../context/AuthContext";


function PaymentsView() {
  const { token } = React.useContext(AuthContext) || {};
  const [payments, setPayments] = React.useState<PaymentsType[]>([]);
  const [error, setError] = React.useState<string | null>(null);
  const [loading, setLoading] = React.useState(true);

  const [pagination, setPagination] = React.useState({
    currentPage: 1,
    perPage: 10,
    totalPages: 0,
  });

  /**
   *
   * @param page Gets the payments for the table
   * @param perPage
   */
  const fetchPayments = async (page: number, perPage: number) => {
    setLoading(true);
    try {
      let options = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await fetch(
        `/api/payments?page=${page}&per_page=${perPage}`,
        options
      );
      
      const data = await response.json();

      if (response.ok) {
        setPayments(data.data);
        setPagination((prev) => ({
          ...prev,
          totalPages: data.pagination.total_pages,
        }));
        setError(null);
      } else {
        setError("Error al traer los pagos");
      }
    } catch (err) {
      setError("Error al traer los pagos");
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (event: any, newPage: number) => {
    setPagination((prev) => ({ ...prev, currentPage: newPage }));
  };

  React.useEffect(() => {
    fetchPayments(pagination.currentPage, pagination.perPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage, pagination.perPage, token]);

  const navigate = useNavigate();

  const handleAddUserClick = () => {
    navigate("/admin/payments/createPayment");
  };

  return (
    <>
      {!loading ? (
        <>
          <Fab
            color="primary"
            variant="extended"
            sx={{
              mr: 1,
              mb: {
                xs: 1,
                sm: 0,
                lg: 0,
              },
              ml: 2,
            }}
            onClick={handleAddUserClick}
          >
            <AddToPhotosOutlinedIcon />
            <Typography
              sx={{
                ml: 1,
                textTransform: "capitalize",
              }}
            >
              {"Añadir nuevo"}
            </Typography>
          </Fab>

          {error && (
            <Alert
              sx={{
                mx: "auto",
                my: 2,
                width: "95%",
              }}
              severity="error"
            >
              {error}
            </Alert>
          )}

          {payments.length > 0 ? (
            <Box>
              <AppTablePayments data={payments} />
              <Stack spacing={2} alignItems="center" sx={{ marginTop: 2 }}>
                <Pagination
                  count={pagination.totalPages}
                  page={pagination.currentPage}
                  onChange={handlePageChange}
                  color="primary"
                  variant="outlined"
                  shape="rounded"
                />
              </Stack>
            </Box>
          ) : (
            <Alert severity="info">No categories found.</Alert>
          )}
        </>
      ) : (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100vh"
        >
          <CircularProgress />
        </Box>
      )}
    </>
  );
}

export default PaymentsView;
